import * as R from 'ramda'

import { format } from 'date-fns'
import en from 'date-fns/locale/en-US'
import { default as de, default as es, default as fr } from 'date-fns/locale/es'
import { ParsedUrlQuery } from 'querystring'

import clsx, { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...args: ClassValue[]) => twMerge(clsx(args))

const locales: { [name: string]: Locale } = {
  en: en,
  es: es,
  'es-ES': es,
  fr,
  de,
}

export function formatDate(value: Date, fmt: string, lng: string) {
  const locale = locales[lng]
  return format(value, fmt, { locale })
}

export function getParamAsString(
  query: ParsedUrlQuery | undefined,
  key: string
): string {
  if (!query) {
    return ''
  }

  const valueOrArray = query[key]
  return Array.isArray(valueOrArray)
    ? <string>R.head(valueOrArray)
    : <string>query[key]
}

export function getParamAsArray(
  query: ParsedUrlQuery | undefined,
  key: string
): string[] {
  if (!query) {
    return []
  }

  const valueOrArray = query[key]
  return Array.isArray(valueOrArray) ? valueOrArray : [<string>query[key]]
}

export function createStrapiMedia(url: string) {
  return {
    data: {
      id: 3,
      attributes: {
        name: 'logo-mcafe.png',
        alternativeText: null,
        caption: null,
        width: 136,
        height: 66,
        formats: null,
        hash: 'logo_mcafe_e793a1fb20',
        ext: '.png',
        mime: 'image/png',
        size: 1.09,
        url: url,
        previewUrl: null,
        provider: 'aws-s3',
        provider_metadata: null,
        createdAt: '2023-01-06T19:43:49.633Z',
        updatedAt: '2023-01-06T19:43:49.633Z',
      },
    },
  }
}
